import React, { useState, useEffect } from 'react';
import './Hero.css';
import { FaArrowRight, FaFileAlt } from 'react-icons/fa';
import profileImg from '../statics/images/profile.jpg';

const Hero = ({ onOpenResume }) => {
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setHasScrolled(window.scrollY > 30);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) {
            const navElement = document.querySelector('.navbar-header');
            const navHeight = navElement ? navElement.offsetHeight : 72;
            const targetPosition = el.getBoundingClientRect().top + window.pageYOffset - navHeight;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    };

    return (
        <section className="hero" id="hero">
            {/* Cyber Grid Overlay */}
            <div className="hero-grid-overlay"></div>

            <div className="hero-inner">
                {/* Left Column: Introductions & Value Proposition */}
                <div className="hero-left">
                    <div className="status-badge">
                        <span className="status-indicator"></span>
                        <span>AVAILABLE FOR FULL-TIME SENIOR ROLES</span>
                    </div>

                    <h1 className="hero-title">
                        <span className="hero-eyebrow-role">Senior Backend Systems Architect &amp; Full-Stack Engineer</span>
                        <span className="hero-name-display">AMIT KUMAR</span>
                    </h1>

                    <p className="hero-summary">
                        Architecting high-concurrency Node.js backend microservices, sub-50ms real-time event loops, resilient cloud infrastructure, and production web &amp; mobile platforms.
                    </p>

                    {/* 1-Second Recruiter Fast-Scan Pill Strip */}
                    <div className="hero-fast-scan-strip" aria-label="Core Engineering Specializations">
                        <span className="fast-scan-pill highlight">Distributed Systems &amp; Node.js</span>
                        <span className="fast-scan-pill">Kafka &amp; Real-Time Sockets</span>
                        <span className="fast-scan-pill">Multi-DB &amp; Mongo Indexing</span>
                        <span className="fast-scan-pill">Next.js SSR &amp; Mobile</span>
                        <span className="fast-scan-pill">AI Platform Data Rails</span>
                    </div>

                    <div className="hero-actions">
                        <button
                            className="primary-hero-btn"
                            onClick={() => scrollToSection('projects')}
                        >
                            <span>Explore Projects</span>
                            <FaArrowRight className="btn-icon-right" />
                        </button>
                        <button
                            className="secondary-hero-btn"
                            onClick={onOpenResume}
                            type="button"
                        >
                            <FaFileAlt className="btn-icon-left" />
                            <span>Executive CV / Specs</span>
                        </button>
                    </div>
                </div>

                {/* Right Column: Candidate Snapshot Card for Recruiters & Hiring Managers */}
                <div className="hero-right">
                    <div className="recruiter-snapshot-card" aria-label="Executive Candidate Overview">
                        <div className="snapshot-card-header">
                            <div className="snapshot-profile-intro">
                                <img
                                    src={profileImg}
                                    alt="Amit Kumar"
                                    className="snapshot-avatar"
                                    width="46"
                                    height="46"
                                    loading="eager"
                                    fetchPriority="high"
                                />
                                <div className="snapshot-title-wrap">
                                    <span className="snapshot-title">CANDIDATE SNAPSHOT</span>
                                    <span className="snapshot-subtitle">Verified Technical Profile</span>
                                </div>
                            </div>
                            <span className="snapshot-verified-pill">
                                <span className="verified-dot"></span>
                                SENIOR IC
                            </span>
                        </div>

                        <div className="snapshot-card-body">
                            <div className="snapshot-row">
                                <span className="snapshot-key">ROLE</span>
                                <span className="snapshot-val highlight">Senior Backend Systems Architect &amp; Full-Stack Engineer</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">BACKEND ENGINE</span>
                                <span className="snapshot-val">Node.js &bull; Kafka &bull; PostgreSQL / MySQL &bull; MongoDB &bull; Redis &bull; AWS</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">PRODUCT SCOPE</span>
                                <span className="snapshot-val">Next.js SSR &bull; React 19 &bull; React Native</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">EXPERIENCE</span>
                                <span className="snapshot-val">4+ Years (Production Leadership)</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">TRACK RECORD</span>
                                <span className="snapshot-val">260+ APIs &bull; &lt;50ms Latency &bull; 10K+ GovTech DAU &bull; AI Pipelines</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">LEADERSHIP</span>
                                <span className="snapshot-val">Lead Architect @ Phnk &bull; Tech Lead @ Grihseva</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">LOCATION</span>
                                <span className="snapshot-val">New Delhi, India (Open to Remote &amp; Relocation)</span>
                            </div>
                            <div className="snapshot-row">
                                <span className="snapshot-key">EDUCATION</span>
                                <span className="snapshot-val">B.Tech in Computer Science (2019)</span>
                            </div>
                        </div>

                        <div className="snapshot-card-footer">
                            <div className="snapshot-verified-tag">
                                <span className="verified-shield">🛡️</span>
                                <span>Verified Production Credentials &bull; 100% Test Pass Rate</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Ambient Micro Scroll Prompt */}
            <div
                className={`hero-scroll-prompt ${hasScrolled ? 'scrolled-hidden' : ''}`}
                onClick={() => scrollToSection('about')}
                role="button"
                tabIndex={0}
                aria-label="Scroll down to explore architecture"
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        scrollToSection('about');
                    }
                }}
            >
                <span className="scroll-prompt-text">Explore Architecture</span>
                <span className="scroll-prompt-arrow" aria-hidden="true">↓</span>
            </div>
        </section>
    );
};

export default Hero;